@if (isAuthenticated) {
  <div class="main-wraper">
    <szz-header [model]="model" (logout)="logout()" (toggleSidebar)="sidebarOpen = !sidebarOpen"></szz-header>
    <div id="wrapper" class="d-flex">
      <szz-sidebar [isOpen]="sidebarOpen" (logout)="logout()"></szz-sidebar>
      <!-- Backdrop za mobilni sidebar -->
      @if (sidebarOpen) {
        <div class="sidebar-backdrop" (click)="sidebarOpen = false">
        </div>
      }
      <div id="content-wrapper" class="flex-grow-1">
        <router-outlet></router-outlet>
        <szz-footer></szz-footer>
      </div>
    </div>
  </div>
}